var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13 24c0-6.075 4.925-11 11-11s11 4.925 11 11-4.925 11-11 11-11-4.925-11-11m10.865-8.802-.08.082a13.7 13.7 0 0 0-2.716 4.15h5.592a13.7 13.7 0 0 0-2.796-4.232m3.429 6.232h-6.858a10.9 10.9 0 0 0-.016 4.63h6.89c.36-1.712.283-3.267-.016-4.63m2.053 4.63a12.9 12.9 0 0 0-.013-4.63h3.294A9 9 0 0 1 33 24c0 .709-.082 1.398-.237 2.06zm-2.64 2h-5.684c.577 1.47 1.488 3.032 2.842 4.67 1.355-1.638 2.265-3.2 2.842-4.67m-.272 4.607c1.133-1.593 1.907-3.135 2.4-4.607h3.2a9.02 9.02 0 0 1-5.6 4.607m2.366-13.237a15.4 15.4 0 0 0-2.152-4.034 9.02 9.02 0 0 1 5.106 4.034zm-7.807-3.916a15.4 15.4 0 0 0-2.065 3.916h-2.684a9.03 9.03 0 0 1 4.75-3.916Zm-2.61 10.546a12.9 12.9 0 0 1 .012-4.63h-3.024A9 9 0 0 0 15 24c0 .709.082 1.398.237 2.06h3.146Zm-2.418 2h2.93c.482 1.44 1.233 2.947 2.326 4.503a9.03 9.03 0 0 1-5.256-4.503",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLanguage);
export default __webpack_public_path__ + "static/media/IcoLanguage.bbd0b0a5fcc0ad51281ab4edf5e179a0.svg";
export { ForwardRef as ReactComponent };